import { Injectable } from '@angular/core';
import { ActionSheetController, AlertController, LoadingController, ModalController, ToastController } from '@ionic/angular';
import { Share } from '@capacitor/share';
import { CallNumber } from '@awesome-cordova-plugins/call-number/ngx';
import { EmailComposer } from '@awesome-cordova-plugins/email-composer/ngx';
import { TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { CurrentPlatformService } from '../current-platform/current-platform.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GlobalService {


  isLoading: boolean = false;

  constructor(
    private alertCtrl: AlertController,
    private toastCtrl: ToastController,
    private loadingCtrl: LoadingController,
    private modalCtrl: ModalController,
    public actionCtl: ActionSheetController,
    private callNumber: CallNumber,
    private emailComposer: EmailComposer,
    private translate: TranslateService,
    private http: HttpClient,
    private currentPlatformService: CurrentPlatformService
  ) { }

  setLoader() {
    this.isLoading = !this.isLoading;
  }

  alertEl: any
  async showAlert(message: string, header?, buttonArray?, inputs?) {
     this.alertEl = await this.alertCtrl.create({
      header: header ? header : 'Authentication failed',
      message: message,
      inputs: inputs ? inputs : [],
      buttons: buttonArray ? buttonArray : ['Okay']
    });

    await this.alertEl.present();
  }

  dismissAllert(){
    this.alertEl.dismiss();
    this.alertEl = null;
  }


  async showToast(msg, color, position, duration = 3000, style?, icon?) {

    const toast = await this.toastCtrl.create({
      message: msg,
      duration: duration,
      color: color,
      position: position,
      cssClass: style ? style : 'default-toast-style',
    });
    toast.present()
  }

  errorToast(msg?, duration = 4000, style?) {
    this.showToast(msg ? msg : this.translate.instant('toast.toastError.unknown'), 'danger', 'bottom', duration, (style) ? style : '');
  }

  async warningToast(msg) {
    const toast = await this.toastCtrl.create({
      message: msg,
      duration: 9000,
      color: 'warning',
      position: 'bottom',
      icon: 'warning'
    });
    toast.present()
  }

  successToast(msg) {
    this.showToast(msg, 'success', 'bottom');
  }


  showLoader(msg?, spinner?) {
    if (!this.isLoading) this.setLoader();
    return this.loadingCtrl.create({
      message: msg,
      spinner: spinner ? spinner : 'crescent',
      cssClass: 'my-loading-class'
    }).then(res => {
      res.present().then(() => {
        if (!this.isLoading) {
          res.dismiss();
        }
      })
    })
      .catch(e => {
        console.log('show loading error: ', e);
      });
  }

  hideLoader() {
    // this.isLoading = false;
    setTimeout(() => {
      if (this.isLoading) this.setLoader();
      return this.loadingCtrl.dismiss().catch(e => console.log('error hide loader: ', e));
    }, 100);
  }

  async createModal(options) {
    const modal = await this.modalCtrl.create(options);
    await modal.present();
    const { data } = await modal.onWillDismiss();
    if (data) return data;
  }

  modalDismiss(val?) {
    let data: any = val ? val : null;
    this.modalCtrl.dismiss(data);
  }


  async createActionSheet(options) {
    const modal = await this.actionCtl.create(options);
    await modal.present();
    const { data } = await modal.onWillDismiss();
    if (data) return data;
  }

  actionSheetDismiss(val?) {
    let data: any = val ? val : null;
    this.actionCtl.dismiss(data);
  }

  // shear
  async shearAccount(uid: string) {
    if (this.currentPlatformService.isNative()) {
      return await Share.share({
        title: this.translate.instant('share.accounttitle'),
        text: this.translate.instant('share.accounttext'),
        url: 'https://' + environment.domain + '/user/' + uid
      });
    }
  }

  async shearOffer(oid: string) {
    if (this.currentPlatformService.isNative()) {
      return await Share.share({
        title: this.translate.instant('share.offertitle'),
        text: this.translate.instant('share.offertext'),
        url: 'https://' + environment.domain + '/offer/' + oid
      });
    }
  }



  async email(options) {
    try {
      const isGmail: any = await this.emailComposer.isAvailable('gmail');
      if (isGmail) await this.emailComposer.open(options);
      else await this.showEmail(options.to);

    } catch (e) {
      console.log(e);
      await this.showEmail(options.to);
    }
  }

  async showEmail(emailAddress) {
    await this.createActionSheet({
      header: 'Email',
      cssClass: 'actionSheet',
      buttons: [{
        text: emailAddress,
        handler: async () => {
          //copy email
        }
      }]
    });
  }


  async callPhoneNumber(number) {
    return await this.callNumber.callNumber(number, true)
      .then((res) => {
        console.log('Launched dialer!', res);
      }).catch((err) => {
        console.log('Error launching dialer', err);
        this.errorToast('Error Calling Phone Number')
      });
  }

  haversine_distance(mk1, mk2) {
    var R = 3958.8; // Radius of the Earth in miles
    var rlat1 = mk1.lat * (Math.PI / 180); // Convert degrees to radians
    var rlat2 = mk2.lat * (Math.PI / 180); // Convert degrees to radians
    var difflat = rlat2 - rlat1; // Radian difference (latitudes)
    var difflon = (mk2.lng - mk1.lng) * (Math.PI / 180); // Radian difference (longitudes)

    var d = 2 * R * Math.asin(Math.sqrt(Math.sin(difflat / 2) * Math.sin(difflat / 2) + Math.cos(rlat1) * Math.cos(rlat2) * Math.sin(difflon / 2) * Math.sin(difflon / 2)));
    return (d * 1.60934);
  }

  nFormatter(num, digits = 1) {
    const lookup = [
      { value: 1, symbol: "" },
      { value: 1e3, symbol: "k" },
      { value: 1e6, symbol: "M" },
      { value: 1e9, symbol: "G" },
      { value: 1e12, symbol: "T" },
      { value: 1e15, symbol: "P" },
      { value: 1e18, symbol: "E" }
    ];
    const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
    var item = lookup.slice().reverse().find(function (item) {
      return num >= item.value;
    });
    return item ? (num / item.value).toFixed(digits).replace(rx, "$1") + item.symbol : "0";
  }

  calculateDate(time?: string) {
    let now = new Date();
    if(time == 'oneweek') return new Date(now.setDate(now.getDate() + (1 * 7)));
    else if (time == 'twoweeks') return new Date(now.setDate(now.getDate() + (2 * 7)));
    else if (time == 'fourweeks') return new Date(now.setDate(now.getDate() + (4 * 7)));
    else if(time == 'onemonth') return  new Date(now.setMonth(now.getMonth() + 1));
    else if(time == 'threemonths') return  new Date(now.setMonth(now.getMonth() + 3));
    else if(time == 'sixmonths') return  new Date(now.setMonth(now.getMonth() + 6));
    else if(time == 'oneyear') return  new Date(now.setMonth(now.getMonth() + 12));
    else return new Date();
  }



  generatRandomString(length = 20) {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    for ( let i = 0; i < length; i++ ) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
   }
   return result;
  }

  getSpecialValue(time: string){
    if(!time || time.length == 0) return { value: false, expired_date: null }
    else return { value: true, expired_date: this.calculateDate(time) }


    // switch (isSpecial) {
    //   case '1w': return { value: true, expired_date: this.calculateDate(1) }
    //   case '1m': return { value: true, expired_date: this.calculateDate(4) }
    //   case '3m': return { value: true, expired_date: this.calculateDate(12) }
    //   case '6m': return { value: true, expired_date: this.calculateDate(24) }
    //   case '1y': return { value: true, expired_date: this.calculateDate(48) }
    //   case 'remove':return { value: false, expired_date: null }
    //   default: return { value: false, expired_date: null }
    // }
  }


  async getHelpNumber() {
    try {
      return await this.http.get<any>('https://us-central1-ibroker-states.cloudfunctions.net/get_help_number').toPromise();
    } catch (e) {
      throw (e);
    }
  }



  nDays(date: any){

    const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
    const firstDate = date.getTime();
    const secondDate = new Date().getTime();

    return Math.round(Math.abs((firstDate - secondDate) / oneDay));
  }




}
